import React, { useState, useEffect } from 'react';
import { FaStar } from 'react-icons/fa';
import GetInTouch from '../GetInTouch/GetInTouch';

const BiziDegerlendirinHome = () => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(null);
  const [comment, setComment] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [ratings, setRatings] = useState([]);
  const [averageRating, setAverageRating] = useState(0);
  const [totalRatings, setTotalRatings] = useState(0);

  // Mevcut değerlendirmeleri getir
  useEffect(() => {
    fetchRatings();
  }, []);

  const fetchRatings = async () => {
    try {
      const baseUrl = process.env.REACT_APP_API_URL?.replace('/api', '') || 'https://mayadangayrimenkul.com.tr';
      const response = await fetch(`${baseUrl}/api/ratings`);
      const data = await response.json();
      
      if (data.success) {
        setRatings(data.data.ratings || []);
        setAverageRating(data.data.average_rating || 0);
        setTotalRatings(data.data.total_ratings || 0);
      } else {
        setError(data.message || 'Değerlendirmeler yüklenemedi');
        // Hata durumunda varsayılan değerler
        setRatings([]);
        setAverageRating(0);
        setTotalRatings(0);
      }
    } catch (error) {
      console.error('Rating fetch error:', error);
      setError('Bağlantı hatası. Lütfen tekrar deneyin.');
      // Hata durumunda varsayılan değerler
      setRatings([]);
      setAverageRating(0);
      setTotalRatings(0);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (rating === 0) {
      setError('Lütfen bir puan seçin');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const baseUrl = process.env.REACT_APP_API_URL?.replace('/api', '') || 'https://mayadangayrimenkul.com.tr';
      const response = await fetch(`${baseUrl}/api/ratings`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          rating: rating,
          comment: comment
        })
      });

      const data = await response.json();

      if (data.success) {
        setSubmitted(true);
        setRating(0);
        setComment('');
        // Yeni değerlendirmeyi ekledikten sonra listeyi güncelle
        setTimeout(() => {
          fetchRatings();
          setSubmitted(false);
        }, 2000);
      } else {
        setError(data.message || 'Bir hata oluştu');
      }
    } catch (error) {
      setError('Bağlantı hatası. Lütfen tekrar deneyin.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

     return (
     <div className="py-16 bg-white dark:bg-main-dark relative overflow-hidden">
        {/* Arka Plan Resmi */}
        <div className="absolute inset-0 z-0">
          <img 
            src="/images/property (39).jpg" 
            alt="" 
            className="w-full h-full object-cover opacity-20 blur-[0.5px]" 
          />
        </div>
        
        {/* İçerik */}
        <div className="max-w-6xl mx-auto px-4 relative z-10">
          {/* Header */}
          <div className="text-center mb-12">
                       <h2 className="text-4xl font-bold text-gray-800 dark:text-slate-300 mb-4">Bizi Değerlendirin ve Bize Ulaşın</h2>
             <p className="text-gray-600 dark:text-slate-300 text-lg">
              Deneyiminizi bizimle paylaşın ve iletişime geçin
            </p>
          </div>

        <div className="grid lg:grid-cols-3 gap-8">
                     {/* Rating Form */}
           <div className="bg-gray-800 dark:bg-white border border-gray-700 dark:border-gray-200 rounded-lg p-6">
             <h3 className="text-2xl font-semibold text-gray-200 dark:text-gray-800 mb-6">Değerlendirmenizi Yapın</h3>
            
            {submitted ? (
              <div className="text-center py-8">
                <div className="text-green-500 text-4xl mb-4">✓</div>
                                 <p className="text-gray-300 dark:text-gray-600">Teşekkürler! Değerlendirmeniz gönderildi.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                {/* Star Rating */}
                <div>
                                     <label className="block text-gray-300 dark:text-gray-700 mb-3">Değerlendirmeniz</label>
                  <div className="flex justify-center space-x-2">
                    {[...Array(5)].map((_, index) => {
                      const ratingValue = index + 1;
                      return (
                        <FaStar
                          key={index}
                          className="cursor-pointer text-3xl transition-colors duration-200"
                          color={ratingValue <= (hover || rating) ? "#EFBB4C" : "#4a5568"}
                                                     style={{ 
                             color: ratingValue <= (hover || rating) ? "#EFBB4C" : "#4a5568"
                           }}
                          onMouseEnter={() => setHover(ratingValue)}
                          onMouseLeave={() => setHover(null)}
                          onClick={() => setRating(ratingValue)}
                        />
                      );
                    })}
                  </div>
                  {rating > 0 && (
                                         <p className="text-center mt-3 text-slate-300 dark:text-gray-600">
                      {rating === 1 && "Çok Kötü"}
                      {rating === 2 && "Kötü"}
                      {rating === 3 && "Orta"}
                      {rating === 4 && "İyi"}
                      {rating === 5 && "Mükemmel"}
                    </p>
                  )}
                </div>

                {/* Comment */}
                <div>
                                     <label className="block text-slate-300 dark:text-gray-700 mb-3">Yorumunuz (İsteğe bağlı)</label>
                  <textarea
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    placeholder="Deneyiminizi paylaşın..."
                                         className="w-full p-4 bg-slate-700 dark:bg-white border border-slate-600 dark:border-gray-300 rounded-lg text-slate-200 dark:text-gray-800 placeholder-slate-400 dark:placeholder-gray-500 focus:outline-none focus:border-[#EFBB4C] resize-none"
                    rows="3"
                    maxLength="500"
                  />
                                     <p className="text-sm text-slate-400 dark:text-gray-500 mt-1">
                    {comment.length}/500 karakter
                  </p>
                </div>

                {/* Error Message */}
                {error && (
                  <div className="bg-red-500/20 border border-red-500/50 rounded-lg p-3">
                    <p className="text-red-400">{error}</p>
                  </div>
                )}

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={rating === 0 || loading}
                  className="w-full bg-[#EFBB4C] hover:bg-[#d4a63f] disabled:bg-slate-600 disabled:cursor-not-allowed text-[#252836] font-semibold py-3 px-6 rounded-lg transition-colors duration-200"
                >
                  {loading ? 'Gönderiliyor...' : 'Değerlendirmeyi Gönder'}
                </button>
              </form>
            )}
          </div>

          {/* Ratings Display */}
          <div className="bg-slate-800 dark:bg-white border border-slate-700 dark:border-gray-200 rounded-lg p-6">
            <h3 className="text-2xl font-semibold text-slate-200 dark:text-gray-800 mb-6">Mevcut Değerlendirmeler</h3>
            
            {/* Average Rating */}
            <div className="text-center mb-6 p-4 bg-slate-700 dark:bg-gray-100 rounded-lg">
              <div className="text-3xl font-bold text-[#EFBB4C] mb-2">
                {averageRating > 0 ? averageRating.toFixed(1) : '-'}
              </div>
              <div className="flex justify-center mb-2">
                {[...Array(5)].map((_, index) => (
                  <FaStar
                    key={index}
                    className="text-xl"
                    color={index < Math.round(averageRating || 0) ? "#EFBB4C" : "#ffffff"}
                                         style={{ 
                       color: index < Math.round(averageRating || 0) ? "#EFBB4C" : "#4a5568"
                     }}
                  />
                ))}
              </div>
              <p className="text-slate-300 dark:text-gray-600">
                {totalRatings || 0} değerlendirme
              </p>
            </div>

            {/* Ratings List */}
            <div className="space-y-3 max-h-64 overflow-y-auto">
              {ratings && ratings.length > 0 ? (
                ratings.slice(0, 5).map((rating) => (
                  <div key={rating.id} className="bg-slate-700 dark:bg-gray-50 rounded-lg p-3">
                    <div className="flex items-center justify-between mb-2">
                      <div className="flex">
                        {[...Array(5)].map((_, index) => (
                          <FaStar
                            key={index}
                            className="text-sm"
                            color={index < rating.rating ? "#EFBB4C" : "#4a5568"}
                                                       style={{ 
                             color: index < rating.rating ? "#EFBB4C" : "#4a5568"
                           }}
                          />
                        ))}
                      </div>
                      <span className="text-sm text-slate-400 dark:text-gray-500">
                        {formatDate(rating.created_at)}
                      </span>
                    </div>
                    {rating.comment && (
                      <p className="text-slate-300 dark:text-gray-700 text-sm">{rating.comment}</p>
                    )}
                  </div>
                ))
              ) : (
                <div className="text-center text-slate-400 dark:text-gray-500 py-8">
                  Henüz değerlendirme bulunmuyor.
                </div>
              )}
            </div>
          </div>

          {/* Get In Touch */}
          <GetInTouch isCompact={true} />
        </div>
      </div>
    </div>
  );
};

export default BiziDegerlendirinHome;
